export default __webpack_public_path__ + "static/media/drawing-woman3-focusfill.1d6caa3c.svg";